// src/translations/permissions_ar.js

export const PERMISSION_LABELS = {
  roots_add: "إضافة فرع",
  roots_edite: "تعديل فرع",
  roots_delete: "حذف فرع",
  roots_show: "عرض الفروع",
  kitchens_add: "إضافة مطبخ",
  kitchens_add_root: "إضافة مطبخ للفرع",
  kitchens_edite: "تعديل مطبخ",
  kitchens_delete: "حذف مطبخ",
  tables_add: "إضافة طاولة",
  tables_edite: "تعديل طاولة",
  tables_qr_print: "طباعة QR للطاولة",
  banks_add: "إضافة خزنة",
  banks_edite: "تعديل خزنة",
  banks_delete: "حذف خزنة",
  banks_add_root: "ربط الخزنة بالفرع",
  banks_show: "عرض الخزن",
  support_make_request: "إنشاء طلب دعم",
  support_show: "عرض طلبات الدعم",
  support_reportes: "تقارير الدعم",
  system_data: "بيانات النظام",
  orders_tables_open_table: "فتح طاولة",
  orders_tables_move_table: "نقل طاولة",
  orders_tables_divide_table: "تقسيم طاولة",
  orders_tables_edite_table: "تعديل طلب الطاولة",
  orders_tables_edite_captain_table: "تعديل بواسطة الكابتن",
  orders_tables_open_other_table: "فتح طاولة أخرى",
  orders_tables_print_table: "طباعة الفاتورة للطاولة",
  orders_tables_print_preparation_table: "طباعة تجهيـز الطاولة",
  orders_tables_close_confirm_table: "تأكيد إغلاق الطاولة",
  orders_tables_delete_table: "حذف طلب الطاولة",
  orders_other_edite_quantity: "تعديل كمية عنصر",
  orders_other_edite_price: "تعديل سعر عنصر",
  orders_other_delete_items: "حذف عناصر",
  orders_other_edite_service: "تعديل خدمة",
  orders_other_edite_discount: "تعديل خصم",
  orders_other_edite_tax: "تعديل ضريبة",
  orders_delivery_make_order: "إنشاء طلب توصيل",
  orders_delivery_edite_order: "تعديل طلب توصيل",
  orders_delivery_edite_delivery_user: "تعديل مندوب التوصيل",
  orders_delivery_open_other_order: "فتح طلب توصيل آخر",
  orders_delivery_change_stauts: "تغيير حالة التوصيل",
  orders_delivery_close_confirm_order: "تأكيد إغلاق طلب التوصيل",
  orders_delivery_api_orders: "طلبات API التوصيل",
  orders_delivery_print_order: "طباعة طلب التوصيل",
  orders_delivery_print_preparation_order: "طباعة تجهيز طلب التوصيل",
  orders_takeaway_make_order: "إنشاء طلب تيك أواي",
  orders_takeaway_edite_order: "تعديل طلب تيك أواي",
  orders_takeaway_edite_captain_order: "تعديل طلب التيك أواي (كابتن)",
  orders_takeaway_close_confirm_table: "تأكيد إغلاق تيك أواي",
  orders_takeaway_print_order: "طباعة تيك أواي",
  orders_takeaway_print_preparation_order: "طباعة تجهيز التيك أواي",
  orders_reservation_add: "إضافة حجز",
  orders_reservation_canacel: "إلغاء حجز",
  orders_reservation_change_status: "تغيير حالة الحجز",
  orders_reservation_edite: "تعديل حجز",
  menu_add_category: "إضافة قسم",
  menu_edite_category: "تعديل قسم",
  menu_delete_category: "حذف قسم",
  menu_add_product: "إضافة منتج",
  menu_edite_product: "تعديل منتج",
  menu_delete_product: "حذف منتج",
  menu_add_offer: "إضافة عرض",
  menu_edite_offer: "تعديل عرض",
  menu_delete_offer: "حذف عرض",
  expenses_show: "عرض المصروفات",
  expenses_add: "إضافة مصروف",
  customers_show: "عرض العملاء",
  customers_edite: "تعديل عميل",
  customers_delete: "حذف عميل",
  customers_add: "إضافة عميل",
  invoice_show: "عرض الفاتورة",
  invoice_show_info: "عرض تفاصيل الفاتورة",
  financial_reports_info: "تقرير مالي",
  financial_reports_other_user_info: "تقرير مالي – مستخدم آخر",
  statistics: "الإحصائيات",
  employees_show: "عرض الموظفين",
  employees_add: "إضافة موظف",
  employees_edite: "تعديل موظف",
  employees_delete: "حذف موظف",
  employees_balance: "رصيد الموظف",
  employees_add_action: "إضافة إجراء للموظف",
  employees_edite_action: "تعديل إجراء الموظف",
  users_show: "عرض المستخدمين",
  users_edite: "تعديل مستخدم",
  users_add: "إضافة مستخدم",
  users_delete: "حذف مستخدم",
  setting: "الإعدادات",
  preparation_screen_show: "عرض شاشة التحضير",
  preparation_screen_confirm_order: "تأكيد الطلب في شاشة التحضير",
  delivery_screen_show: "عرض شاشة التوصيل",
  delivery_screen_confirm_order: "تأكيد الطلب في شاشة التوصيل",
  other: "أخرى",
};

export const GROUP_LABELS = {
  roots: "الفروع",
  kitchens: "المطابخ",
  tables: "الطاولات",
  banks: "الخزن",
  support: "الدعم",
  orders: "الطلبات",
  menu: "القائمة",
  expenses: "المصروفات",
  customers: "العملاء",
  invoice: "الفواتير",
  financial: "المالية",
  statistics: "الإحصائيات",
  employees: "الموظفين",
  users: "المستخدمين",
  setting: "الإعدادات",
  preparation: "التحضير",
  delivery: "التوصيل",
  takeaway: "تيك أواي",
  other: "أخرى",
};
